import React, { Component } from 'react';
import { prop } from 'ramda';
import { withAsyncActions } from 'react-async-client';
import { without, contains, append } from 'ramda';
import { withState } from 'recompose';

import { fullAutoOptions } from 'constants/asyncClient';
import { getApprovalApplicationList, getApprovalApplicationListCounters, putApprovalApplication } from 'actions/asyncActions';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { getStatusPayload, setFilter } from 'helpers/filterHelpers';
import { defaultApprovalApplicationListFilters } from 'constants/defaultFilters';
import ApprovalApplicationListTable from './ApprovalApplicationListTable';

@withState('selected', 'setSelected', [])
@withAsyncActions({
    getApprovalApplicationListCounters: getApprovalApplicationListCounters
        .withPayload(() => ({
            resp: true
        })),
    getApprovalApplicationList: getApprovalApplicationList
        .withPayload(props => ({
            ...setFilter(
                prop('status', getStatusPayload(props)),
                defaultApprovalApplicationListFilters
            ),
            resp: true,
        }))
        .withPendingHandler(props => props.getApprovalApplicationListCounters.refresh())
        .withOptions(fullAutoOptions),
    putApprovalApplication: putApprovalApplication
        .withSuccessHandler(({ getApprovalApplicationList, setSelected }) => {
            getApprovalApplicationList.refresh();
            setSelected([]);
        })
})
@withRouteOptions
export default class ApprovalApplicationListView extends Component {
    static routeOptions = {
        title: 'menu.application'
    }

    onSelect = (value) => {
        const { selected, setSelected } = this.props;

        if (contains(value, selected)) {
            setSelected(without([value], selected));
        } else {
            setSelected(append(value, selected));
        }
    }

    render() {
        return (
            <ApprovalApplicationListTable
                {...this.props}
                selected={this.props.selected}
                onSelect={this.onSelect}
            />
        );
    }
}
